import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';

const states: Ng1StateDeclaration[] = [
    {
        component: 'wtTarget',
        name: 'target',
        url: '/target/:identifierGuid/:beginDate/:endDate',
        abstract: true,
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            dates: Resolve.datesResolve
        },
        params: {
            beginDate: '',
            endDate: ''
        },
        redirectTo: 'target.general',
        data: {
            visible: false,
            isAuthenticated: true,
            isConnected: true,
            editButtonVisibility: () => false,
            breadcrumbs: {
                level3StateName: 'identifiers',
                level4: ''
            }
        }
    },
    {
        template: '<wt-target-general class="flex-directive"></wt-target-general>',
        name: 'target.general',
        url: '/general',
        data: {
            displayName: 'Identifiers',
            icon: 'fa-table',
            isAuthenticated: true,
            isConnected: true,
            editButtonVisibility: () => false,
            breadcrumbs: {
                level3StateName: 'Identifier',
                level4: '',
                level5: 'General'
            }
        }
    }];

export default states;